import { Expand } from 'lucide-react';

import { POSITION_CLASSES } from '@/constants';

function ExpandMapControl({ className, onClick, position }: {
  className?: string,
  onClick: () => void,
  position: string,
}) {
  const positionClass = (position && POSITION_CLASSES[position as keyof typeof POSITION_CLASSES]) || POSITION_CLASSES.topright;

  return (
    <div className={`${className} ${positionClass}`}>
      <div className="leaflet-control leaflet-bar">
        <a
          className="leaflet-control-expand-map"
          href="#"
          title="Expand map"
          role="button"
          aria-label="Expand map"
          onClick={(e) => {
            onClick();
            e.preventDefault();
          }}
        >
          <div className="flex items-center justify-center w-full h-full">
            <Expand className="w-5 h-5 text-gray-600" />
          </div>
        </a>
      </div>
    </div >
  );
}

export default ExpandMapControl;
